import { createStore } from 'vuex';
import { LotsTools } from '@annto/ui';
import { logout } from '../utils/index';

import user from './modules/user';
import breadcrumb from './modules/breadcrumb';
import tagsNav from './modules/tags_nav';
import tagsView from './modules/tagsView';
import micro from './modules/micro';

const { userStore } = new LotsTools({
  baseUrl: '',
  listen: [
    {
      key: 'logout',
      cb: () => {
        logout();
      },
    },
  ],
});

export default createStore<any>({
  state: {
    userStore,
    ...user.state,
    ...breadcrumb.state,
    ...tagsNav.state,
    ...tagsView.state,
    ...micro.state,
    tenantDialog: {
      tenantsList: [],
      currentPage: 1,
      total: 0,
      pageSize: 10,
    },
  },
  getters: {
    ...userStore.getters,
    ...user.getters,
    ...breadcrumb.getters,
    ...tagsNav.getters,
    ...tagsView.getters,
    ...micro.getters,
  },
  mutations: {
    ...userStore.mutations,
    ...user.mutations,
    ...breadcrumb.mutations,
    ...tagsNav.mutations,
    ...tagsView.mutations,
    ...micro.mutations,
  },
  actions: {
    ...userStore.actions,
    ...user.actions,
    ...breadcrumb.actions,
    ...tagsNav.actions,
    ...tagsView.actions,
    ...micro.actions,
  },
});
